module.exports = __webpack_public_path__ + "img/buy-buttons-black.f0927171.png";